import React from 'react'
import PropTypes from 'prop-types'
import './IconText.scss'

const IconText = ({ icon, children }) => (
  <div className="icon-text">
    <div className="icon-text__icon">
      <span className="icon-text__icon--small">{icon}</span>
    </div>
    <div className="icon-text__text">
      <p>{children}</p>
    </div>
  </div>
)

IconText.propTypes = {
  icon: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}

export default IconText
